import { render, staticRenderFns } from "./dd.vue?vue&type=template&id=0073c19c&scoped=true&"
import script from "./dd.vue?vue&type=script&lang=js&"
export * from "./dd.vue?vue&type=script&lang=js&"
import style0 from "./dd.vue?vue&type=style&index=0&id=0073c19c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0073c19c",
  null
  
)

export default component.exports